import React from 'react';
import { PRIVACY_POLICY_HTML } from './privacyPolicyContent';
import '../legalDoc.scss';

/**
 * Facilon Global Privacy Policy, ported verbatim from Laravel's privacy-policy.blade.php —
 * the same 22 sections and jurisdiction addenda that facilonservices.co.in publishes.
 *
 * <p>This page previously held a hand-written two-section summary. That was a different
 * document from the published policy, and the registration consent screens link here while
 * stating that the Privacy Policy prevails on any inconsistency — so an investor was
 * attesting to a digest while the wording pointed at the full document. The legal text now
 * matches its source; only the presentation is ours.
 *
 * <p>Opened in a new tab from the Consent Centre and the registration consents, so it stays
 * public and standalone but carries the current app's chrome.
 */
export const PrivacyPolicy: React.FC = () => {
  return (
    <div>
      <div className="bg-white border-b border-slate-200 py-2 px-6 flex items-center">
        <img src="/assets/images/logo.png" alt="Facilon" style={{ height: 40, objectFit: 'contain' }} />
      </div>
      <div className="public-page bg-slate-50 py-8 min-h-screen">
        <div className="container max-w-5xl mx-auto px-4 space-y-6">
          <div className="bg-[#052f55] p-6 rounded-xl shadow-sm flex items-center justify-between flex-wrap gap-4">
            <div>
              {/* Explicit text-white: a global h1 colour rule otherwise overrides the
                  banner's inherited white and the title vanishes on the navy ground. */}
              <h1
                className="text-2xl font-bold m-0 flex items-center gap-2 text-white"
                style={{ color: '#ffffff' }}
              >
                <i className="bi bi-shield-lock-fill text-red-500"></i>
                <span>Facilon Global Privacy Policy</span>
              </h1>
              <p className="text-slate-300 text-xs mt-1 mb-0">
                How Facilon collects, uses and protects your personal data.
              </p>
            </div>
            <a
              href="mailto:privacy@facilonservices.com"
              className="bg-white text-[#052f55] hover:bg-slate-100 font-bold text-xs px-4 py-2 rounded-lg transition-colors no-underline inline-flex items-center gap-2"
            >
              <i className="bi bi-envelope-fill"></i>
              <span>Grievance Officer</span>
            </a>
          </div>
          <div
            className="bg-white border border-slate-200 rounded-xl p-6 shadow-xs legal-doc"
            dangerouslySetInnerHTML={{ __html: PRIVACY_POLICY_HTML }}
          />
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
